// Source: app/scripts/directives/input-field-number.js
/*
 * Directive for generic combo (select)
 *
 */

Auction.directive('inputFieldNumber', [
  'crudService',
  'settings',
  function(crudService, settings) {
    return {
      restrict: 'E',
      templateUrl: 'directives/inputFieldNumber.html',
      scope: {
        fProperties: '@',
        fEntity: '=',
        /**
         * The label for translating entity name
         */
        fLabel: '@',
        /**
         * The name of the field
         */
        ifName: '@',
        /**
         * whether the field is required or not
         */
        ifRequired: '=',

        /**
         * the model of the field
         */
        fModel: '=',
        /**
         * The fields that start with <b>if-</b> will be copied to the input
         * element, without the <b>if-</b> part
         */
        isDisabled: '='
      },
      compile: function(tElem, attrs) {
        var attrPat = /^if[A-Z]/;
        var input = $(tElem.find('input')[0]);
        if (!attrs.ifType) {
          attrs.ifType = 'text';
        }
        for (var a in attrs) {
          if (attrPat.test(a) && a != 'ifRequired') {
            input.attr(a.substring(2).replace(/\W+/g, '-').replace(
              /([a-z\d])([A-Z])/g, '$1-$2'), attrs[a]);
          }
        }
        if (!attrs['fLabel']) {
          attrs['fLabel'] = settings.translationPrefix + attrs['ifName'];
        }

        return function(scope, element, attrs, ctrl, transclude, formCtrl) {
          var baseClass = scope.baseClass || "form-group";

          var div = element.find("div");
          div.addClass(baseClass);
          scope.input = $(element.find('input')[0]);
          scope.input.bind('blur', function() {
            scope.$apply(function() {
              scope.edit = false;
            })
          });
          scope.onEdit = function() {
            var fps = scope.fieldProperties,
              pf = scope.propertiesField,
              tfp = fps && fps[pf];
            if (tfp && tfp.disabled) {
              return;
            }
            scope.edit = true;

            // scope.input = element.find('input')[0];
            scope.input.focus(100);
          }
          scope.form = element.parent().controller('form');
          scope.fName = scope.ifName;
          scope.fType = attrs.ifType;
          scope.message = attrs.message || 'generic.required';
          scope.validationParams = attrs;
        };
      },
      controller: function($scope, $element) {
        $scope.edit = false;
        $scope.$watch('fEntity', function(n, o) {
          if (n === o || !n) return;
          $scope.propertiesField = $scope.fProperties || $scope.ifName;
          $scope.fieldProperties = n.fieldProperties;

        });

        $scope.propertiesField = $scope.fProperties || $scope.ifName;
        $scope.fieldProperties = $scope.fEntity.fieldProperties;

      }
    };
  }
]);
